import React from 'react';

const PolicyHeader = () => {
    return (
        <div className="policy-header">
            <div className="policy-header-left">
                <h1>We want to protect you and your ideas.</h1>
                <p>
                    Agreeing to this states that you will not share or talk about other peoples
                    ideas shared on this platform.
                </p>
            </div>
            <div className="policy-header-right">
                <div>
                    <h3>Do's</h3>
                    <p>
                        Share ideas and campaigns you want help with. As a startup you can be open
                        since you're protected. No-one can talk about your new campaign ideas or
                        product features shared on this platform.
                    </p>
                    <p>
                        You don't have to donate but we highly encourage it, even if it's a small
                        amount. People take the time to give you their feedback.
                    </p>
                </div>
                <div>
                    <h3>Don'ts</h3>
                    <p>We advise you not to post highly sensitive material on this platform.</p>
                    <p>
                        If users provide general answers to questions these can't be protected, only
                        specific design ideas.
                    </p>
                </div>
            </div>
        </div>
    );
};

const PolicyPage = () => {
    return (
        <div className="scrollbar policy-page" id="style-4">
            <div className="force-overflow">
                <h5>User Agreement</h5>
                <p>
                    Sigh view am high neat half to what. Sent late held than set why wife our. If an
                    blessing building steepest. Agreement distrusts mrs six affection satisfied. Day
                    blushes visitor end company old prevent chapter. Consider declared out expenses
                    her concerns. No at indulgence conviction particular unsatiable boisterous
                    discretion. Direct enough off others say eldest may exeter she. Possible all
                    ignorant supplied get settling marriage recurred.
                </p>
                <p>
                    Why end might ask civil again spoil. She dinner she our horses depend. Remember
                    at children by reserved to vicinity. In affronting unreserved delightful
                    simplicity ye. Law own advantage furniture continual sweetness bed agreeable
                    perpetual. Oh song well four only head busy it. Afford son she had lively
                    living. Tastes lovers myself too formal season our valley boy. Lived it their
                    their walls might to by young.
                </p>
                <p>
                    Admiration stimulated cultivated reasonable be projection possession of. Real no
                    near room ye bred sake if some. Is arranging furnished knowledge agreeable so.
                    Fanny as smile up small. It vulgar chatty simple months turned oh at change of.
                    Astonished set expression solicitude way admiration.
                </p>
                <p>
                    Answer misery adieus add wooded how nay men before though. Pretended belonging
                    contented mrs suffering favourite you the continual. Mrs civil nay least means
                    tried drift. Natural end law whether but and towards certain. Furnished
                    unfeeling his sometimes see day promotion. Quitting informed concerns can men
                    now. Projection to or up conviction uncommonly delightful continuing. In
                    appetite ecstatic opinions hastened by handsome admitted.
                </p>
                <p>
                    Her companions instrument set estimating sex remarkably solicitude motionless.
                    Property men the why smallest graceful day insisted required. Inquiry justice
                    country old placing sitting any ten age. Looking venture justice in evident in
                    totally he do ability. Be is lose girl long of up give. Trifling wondered
                    unpacked ye at he. In household certainty an on tolerably smallness difficult.
                    Many no each like up be is next neat. Put not enjoyment behaviour her supposing.
                    At he pulled object others.
                </p>
                <p>
                    Her extensive perceived may any sincerity extremity. Indeed add rather may
                    pretty see. Old propriety delighted explained perceived otherwise objection saw
                    ten her. Doubt merit sir the right these alone keeps. By sometimes intention
                    smallness he northward. Consisted we otherwise arranging commanded discovery it
                    explained. Does cold even song like two yet been. Literature interested
                    announcing for terminated him inquietude day shy. Himself he fertile chicken
                    perhaps waiting if highest no it. Continued promotion has consulted fat
                    improving not way.
                </p>
                <p>
                    Was drawing natural fat respect husband. An as noisy an offer drawn blush place.
                    These tried for way joy wrote witty. In mr began music weeks after at begin.
                    Education no dejection so direction pretended household do to. Travelling
                    everything her eat reasonable unsatiable decisively simplicity. Morning request
                    be lasting it fortune demands highest of.
                </p>
                <p>
                    Tolerably earnestly middleton extremely distrusts she boy now not. Add and
                    offered prepare how cordial two promise. Greatly who affixed suppose but enquire
                    compact prepare all put. Added forth chief trees but rooms think may. Wicket do
                    manner others seemed enable rather in. Excellent own discovery unfeeling
                    sweetness questions the gentleman. Chapter shyness matters mr parlors if mention
                    thought.
                </p>
                <p>
                    Debating me breeding be answered an he. Spoil event was words her off cause any.
                    Tears woman which no is world miles woody. Wished be do mutual except in effect
                    answer. Had boisterous friendship thoroughly cultivated son imprudence
                    connection. Windows because concern sex its. Law allow saved views hills day
                    ten. Examine waiting his evening day passage proceed.
                </p>
            </div>
        </div>
    );
};

export { PolicyHeader, PolicyPage };
